export default {"src":"/_next/static/media/first_nav_icon03.328c6248.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};